import { mittausCacheGet } from '../../../utils/mittausCache';

const TH = { font: 'Lato', fontSize: 8, bold: true, color: '#fff', fillColor: '#04aa00', alignment: 'center' };
const TD = (text, align = 'center') => ({ text: text ?? '—', font: 'Lato', fontSize: 8, alignment: align });

const layout = {
  hLineWidth: () => 0.5, vLineWidth: () => 0.5,
  hLineColor: () => '#adb5bd', vLineColor: () => '#adb5bd',
  paddingLeft: () => 3, paddingRight: () => 3,
  paddingTop: () => 3, paddingBottom: () => 3,
  fillColor: (row) => row === 0 ? '#04aa00' : (row % 2 === 0 ? '#f8f9fa' : null),
};

const headerRow = [
  { text: 'Tunnus',                                  ...TH },
  { text: 'Kloridipitoisuus betonin painosta (%)',   ...TH },
];

function blockCaption(blockData, projekt) {
  const raw = blockData?.caption;
  if (!raw) return projekt?.nimi ?? '';
  return (typeof raw === 'string' ? raw : raw.value ?? '').trim() || (projekt?.nimi ?? '');
}

export function renderKloridipitoisuusBlock({ block, content, tableCounter }) {
  const blockData = block?.data ?? {};
  const projekt = blockData.mittausProjektiId ? mittausCacheGet(blockData.mittausProjektiId) : null;
  const rows = (projekt?.kohteet ?? [])
    .flatMap(k => k.data ?? [])
    .filter(r => r.tunnus || r.rakenneosa || r.kloridipitoisuus);
  if (!rows.length) return;

  const tblNum = tableCounter ? ++tableCounter.value : null;

  const bodyRows = rows.map(row => [
    TD(row.tunnus || '—'),
    TD(row.kloridipitoisuus || '—'),
  ]);

  content.push({
    stack: [
      { table: { headerRows: 1, widths: ['*', '*'], body: [headerRow, ...bodyRows] }, layout, margin: [0, 5, 0, 0] },
      ...(tblNum !== null ? [{
        text: [{ text: `Taulukko ${tblNum}. `, bold: true }, { text: blockCaption(blockData, projekt), bold: false }],
        font: 'Lato', fontSize: 9,
        margin: [0, 4, 0, 0],
      }] : []),
    ],
    margin: [0, 0, 0, 15],
  });
}
